import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  NFTExperiencedTeam,
  NFTInnovative,
  NFTCustomized,
  NFTPrimeSecurity,
  NFTScalable,
  NFTUserCentric,
} from "../../../app-constants";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Choose TekRevol As Your NFT Development Company</h2>
            <p>
              At TekRevol, our premier NFT development solutions are founded on
              professional proficiency knowledge and state-of-the-art
              technologies. Our primary goal is to provide you with the most
              effective solutions with a focus on security and scalability, as
              well as creating the best user experience throughout the
              development process. 
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {NFTExperiencedTeam}
                    </div>
                    <div className="voice_service_head">
                      <h5>Experienced Team</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our team comprises blockchain experts with extensive
                      experience in developing and deploying NFT solutions
                      across various industries.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{NFTInnovative}</div>
                    <div className="voice_service_head">
                      <h5>Innovative Technologies</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We utilize the latest blockchain technologies and
                      frameworks to create advanced and future-proof NFT
                      ecosystems.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{NFTCustomized}</div>
                    <div className="voice_service_head">
                      <h5>Customized Solutions</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We offer tailor-made NFT development services that align
                      with your specific business requirements and goals.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{NFTPrimeSecurity}</div>
                    <div className="voice_service_head">
                      <h5>Prime Security</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We implement stringent security measures to protect your
                      NFTs and ensure the integrity of transactions.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{NFTScalable}</div>
                    <div className="voice_service_head">
                      <h5>Scalable Infrastructure</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our solutions are designed to scale with your business,
                      accommodating increasing transaction volumes and user
                      growth.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{NFTUserCentric}</div>
                    <div className="voice_service_head">
                      <h5>User-Centric Design</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We prioritize user experience, creating intuitive and
                      engaging interfaces for both NFT creators and buyers.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
